// Shopify owns the preferences UI and consent. Do not load a replacement banner.
(() => {
  const available = () => typeof window.privacyBanner?.showPreferences === 'function';
  const refresh = () => document.querySelectorAll('[data-cookie-preferences]').forEach(button => {
    button.hidden = !available();
  });
  refresh();
  window.addEventListener('load', refresh, { once: true });
  // The native banner may arrive asynchronously, or the footer may be re-rendered.
  document.addEventListener('load', event => { if (event.target.tagName === 'SCRIPT') refresh(); }, true);
  document.addEventListener('shopify:section:load', refresh);
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-cookie-preferences]');
    if (!button || button.disabled) return;
    button.disabled = true;
    try {
      if (!available()) throw new Error('Native privacy preferences unavailable');
      await window.privacyBanner.showPreferences();
    } catch {
      // No dead action when the native API is disabled or fails to initialize.
      button.hidden = true;
      button.closest('nav')?.querySelector('a')?.focus();
    } finally {
      button.disabled = false;
    }
  });
})();
